import React from 'react';
import { IIcon } from '../../interfaces/IIcon';
import { Icon } from '../Icon';

export function AxisIcon(props: IIcon) {
    const viewBox = props.viewBox || '0 0 19 20';
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={viewBox}
            style={props.style}
            className={props.className}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.1363 0.24707H0.863694C0.386719 0.24707 0 0.633843 0 1.11046V18.3837C0 18.8603 0.386719 19.2471 0.863694 19.2471H18.1363C18.6133 19.2471 19 18.8604 19 18.3837V1.11046C19 0.633843 18.6133 0.24707 18.1363 0.24707ZM1.16228 18.0837V1.41797H17.802V18.0837H1.16228ZM4.00605 6.54048H2.62706C2.5252 6.54048 2.43332 6.47927 2.3944 6.38495C2.35509 6.29051 2.37661 6.18209 2.44904 6.11021L4.67527 3.88332C4.77377 3.78499 4.93358 3.78499 5.03202 3.88332L7.25826 6.11021C7.33068 6.18209 7.3522 6.29051 7.3129 6.38495C7.27398 6.47927 7.18209 6.54048 7.08028 6.54048H5.7013V13.546H12.707V12.1669C12.707 12.0651 12.7682 11.9733 12.8626 11.9343C12.9569 11.8954 13.065 11.917 13.1374 11.9889L15.3636 14.2156C15.4621 14.3142 15.4621 14.4731 15.3636 14.5716L13.1374 16.7982C13.065 16.8702 12.9569 16.8919 12.8626 16.853C12.7682 16.814 12.707 16.7221 12.707 16.6203V15.2412H4.85367C4.38563 15.2412 4.00605 14.8621 4.00605 14.3935V6.54048Z"
            />
        </Icon>
    );
}
